import type { IOffer } from "@bbj-types/offer";

export const formatName = <T extends { firstName?: string; lastName?: string }>(obj: T): string => {
  if (obj.firstName && obj.lastName) {
    return `${obj.firstName} ${obj.lastName}`;
  }
  if (obj.firstName) {
    return obj.firstName;
  }
  if (obj.lastName) {
    return obj.lastName;
  }
  return "";
};

export const formatDate = (date: Date | string, timeZone: string) => {
  let parsedDate: Date;
  if (typeof date === "string") {
    try {
      parsedDate = new Date(date);
    } catch (e) {
      throw new Error("Invalid date format");
    }
  } else {
    parsedDate = date;
  }
  return parsedDate.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone,
  });
};

export const formatPublishDate = (offer: IOffer, timeZone: string) => {
  if (offer.isPermanent) {
    return "Offre permanente";
  }
  if (offer.publicationDate) {
    const date = new Date(offer.publicationDate);
    const dateString = date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone,
    });
    const updatedDate = new Date(offer.publicationUpdatedDate);
    const updatedDateString = updatedDate.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone,
    });

    if (offer.publicationUpdatedDate && updatedDate.getTime() > date.getTime()) {
      if (offer.editor) {
        return `Actualisée par ${formatName(offer.editor)} le ${updatedDateString}`;
      }
      if (offer.creator) {
        return `Créée par ${formatName(offer.creator)} le ${updatedDateString}`;
      }
      return `Actualisée le ${updatedDateString}`;
    }
    if (offer.creator) {
      return `Publiée par ${formatName(offer.creator)} le ${dateString}`;
    }
    return `Publiée le ${dateString}`;
  }
  return "";
};
